import { observer } from "mobx-react";

import Faqed from "components/UI/Faqed/Faqed";
import InputLink from "components/InputLink/InputLink";
import UploadFile from "components/UploadFile/UploadFile";
import { CategoryInput } from "../componentsSettingsStep/CategoryInput/CategoryInput";
import { Phrase } from "../componentsSettingsStep/Phrase/Phrase";
import CityInput from "../componentsSettingsStep/CityInput/CityInput";
import InstructionsScreenPopup from "../componentsSettingsStep/InstructionsScreenPopup/InstructionsScreenPopup";
import CheckBox from "components/UI/CheckBox/CheckBox";

import AppStore from "AppStore";
import popupStore from "components/Popup/PopupStore";

import "./IsDesktopSettingsStep.scss";

export const IsDesktopSettingsStep = observer(
  ({
    store,
    modeId,
    needFullParams,
    nameSite,
    linkRef,
    categoryRef,
    cityRef,
    searchPhrasesRef,
    screenshotRef,
    freeOnlineServiceRef,
    onChangeLinkToAd,
    onChangeAddress,
    descriptionScreenshot,
    descriptionCategory,
    descriptionCity,
    iconUploadFile,
    isPresave,
  }) => {
    return (
      <div className="market-step1">
        <div className={`market-step1__link_settings ${!needFullParams ? "without-border" : ""}`}>
          {needFullParams && (
            <div className={`market-step1__link_settings-screen ${AppStore.uploadedFileError ? " error" : ""}`} ref={screenshotRef}>
              <Faqed className="market-step1__label-faqed" text={descriptionScreenshot}>
                <p className="market-step1__label">Прикрепите скриншот объявления</p>
              </Faqed>
              <UploadFile
                title="Прикрепите скриншот"
                icon={iconUploadFile}
                className="avito-upload-file__add-button"
              />
              <button
                className="market-step1__link_settings-screen-instructions"
                type="button"
                aria-label="Инструкция 'Как сделать скриншот?'"
                onClick={() => {
                  store.setInstructionsScreen(true);
                  popupStore.open("instructions-screen");
                }}
              >
                Как сделать скриншот?
              </button>
            </div>
          )}
          {!store.market.isPharmacy ? 
            <div className="market-step1__link_settings-link" ref={linkRef}>
              {!store.market.isMusicPlatform && (
                <>
                  <p className="market-step1__label">{store.market.targetLinkComment}</p>
                  <InputLink
                    defaultValue={store.linkToAd}
                    onChange={onChangeLinkToAd}
                    errortext={store.linkError}
                  />
                </>
              )}
              {store.market.isMusicPlatform && (
                <div className="market-step1__music-fields">
                  <div className="market-step1__music-fields-grid">
                    <div className="market-step1__link_settings-link">
                      <p className="market-step1__label">Название трека</p>
                      <InputLink
                        placeholder="Точное название, как на платформе"
                        defaultValue={store.trackTitle}
                        onChange={(e) => store.setTrackTitle(e.target.value)}
                        errortext={store.trackTitleError}
                      />
                    </div>
                    <div className="market-step1__link_settings-link">
                      <p className="market-step1__label">Название альбома</p>
                      <InputLink
                        placeholder="Точное название, как на платформе"
                        defaultValue={store.albumTitle}
                        onChange={(e) => store.setAlbumTitle(e.target.value)}
                        errortext={store.albumTitleError}
                      />
                    </div>
                    <div className="market-step1__link_settings-link">
                      <p className="market-step1__label">Исполнитель(-и)</p>
                      <InputLink
                        placeholder="Если исполнителей несколько, укажите всех"
                        defaultValue={store.musician}
                        onChange={(e) => store.setMusician(e.target.value)}
                        errortext={store.musicianError}
                      />
                    </div>
                    <div className="market-step1__link_settings-link">
                      <p className="market-step1__label">{isPresave ? "Ссылка на пресейв" : "Ссылка на трек/пресейв"}</p>
                      <InputLink
                        placeholder="Введите ссылку в формате https://..."
                        defaultValue={store.linkToAd}
                        onChange={(e) => store.setLinkToAd(e.target.value)}
                        errortext={store.linkError}
                      />
                    </div>
                  </div>
                </div>
              )}
              {store.market.id === "avito" && store.currentCalculator.actions.some(action => action.type === 'MAIN.REVIEW' && action.count > 0) && 
                <div className="market-step1__check" ref={freeOnlineServiceRef}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                    <path d="M8.80092 8.67034L5.73235 6.42441L6.13714 10.185H3.81286L4.21765 6.41135L1.14908 8.67034L0 6.63333L3.48642 5.10558L0 3.57782L1.14908 1.52776L4.23071 3.83898L3.81286 0H6.13714L5.71929 3.83898L8.80092 1.52776L9.95 3.57782L6.47664 5.10558L9.95 6.63333L8.80092 8.67034Z" fill="#FF7373"/>
                  </svg>
                  <CheckBox
                    classes={["market-step1__check-link", store.freeOnlineServiceError ? "error" : ""]}
                    title={<><b>Я проверил(-а),</b> что в объявлении по ссылке есть бесплатная онлайн-услуга</>}
                    checked={store.isFreeOnlineService}
                    onClick={() => store.setIsFreeOnlineService(!store.isFreeOnlineService)}
                  />
                </div>                
              }
            </div>
          :
            <div className="market-step1__link_settings-link">
              <p className="market-step1__label">{store.market.targetLinkComment}</p>
              <InputLink
                placeholder="Например, 100 мл"
                defaultValue={store.dosage}
                onChange={(e) => { store.setDosage(e.target.value) }}
              />
              <p className="market-step1__mark">Поле необязательно для заполнения</p>
            </div>
          }
        </div>
        {needFullParams && (
          <div className={`market-step1__parameters ${!store.market.isPharmacy ? "" : "with-border-bottom"}`}>
            <div className="market-step1__parameters_settings">
              {!store.market.isPharmacy && 
                <div ref={categoryRef}>
                  <Faqed className="market-step1__label-faqed" text={descriptionCategory}>
                    <p className="market-step1__label">Выберите категорию товара</p>
                  </Faqed>
                  <CategoryInput store={store} error={store.categoryError} />
                </div>
              }
              <div ref={cityRef}>
                <Faqed className={`market-step1__label-faqed ${!store.market.isPharmacy ? "" : "other-padding"}`} text={descriptionCity}>
                  {!store.market.isPharmacy 
                    ? <p className="market-step1__label">Укажите город продвижения поисковой фразы</p> 
                    : <p className="market-step1__label">Укажите регион продвижения</p>
                  }
                </Faqed>
                <CityInput onChange={onChangeAddress} error={store.cityError} />
              </div>
            </div>
            <div className="market-step1__parameters_settings-phrase" ref={searchPhrasesRef}>
              {!store.market.isPharmacy ?
                <>
                  {/* <p className="market-step1__label">Какие поисковые фразы надо продвинуть на {getDativeCase(nameSite)}?</p> */}
                  <p className="market-step1__label">По каким поисковым фразам пользователь должен найти объявление?</p>
                  <p className="market-step1__note"><i>Подсказка:</i> используйте <b>точные и осмысленные запросы</b> <br /> Не рекомендуются однословные формулировки</p>
                  <Phrase store={store} />
                </> 
              : 
                <>
                  <p className="market-step1__label">Поисковый запрос</p>
                  <p className="market-step1__note">Товар <b>должен быть в ТОП-5 выдачи</b> по запросу</p>
                  <Phrase store={store} maxPhrases={4} />
                </>
              }   
            </div>
          </div>
        )}
        {store.market.isPharmacy &&
          <div className={`market-step1__request ${store.market.isPharmacy ? "another-position" : ""}`}>
            <div className="market-step1__request-title">
              <p className="market-step1__label">Комментарий для исполнителя</p>
            </div>
            <textarea
              className="market-step1__textarea"
              placeholder="Укажите уникальный фильтр, чтобы облегчить поиск товара исполнителями"
              value={store.commentComment}
              onChange={(e) => {
                store.setCommentComment(e.target.value);
              }}
            />
            <p className="market-step1__mark">Поле необязательно для заполнения</p>
          </div>
        }
        {store.instructionsScreen && (
          <InstructionsScreenPopup
            marketStore={store}
            popupStore={popupStore}
          />
        )}
      </div>
    );
  }
);